import cn from 'classnames';
import type { ReactNode } from 'react';

import { Typography } from '@sravni/react-design-system';

import { Card } from './Card';
import styles from './styles.module.scss';

const { Text } = Typography;

type SectionProps = {
  headline: string;
  children: ReactNode;
};

export const PromoSection = ({ headline, children }: SectionProps) => (
  <div className={cn(styles.root, 'h-mb-20')}>
    <Text size={16} className="h-color-D60 h-mb-4">
      {headline}
    </Text>
    {children}
  </div>
);

PromoSection.Card = Card;
